import { useGrowl } from "PFApp/use_growl";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import DataTable from "PFComponents/data_table/data_table";
import { parseResponseErrors } from "PFCore/helpers/parse_errors";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./cv_templates_list_page.less";

const CvTemplatesListPage = ({ cvTemplates, accountId, fetchTemplates }) => {
  const { t } = useTranslation("saasAdmin");
  const growl = useGrowl();

  const renderActions = (item) => (
    <div className={css.actions}>
      <ButtonLink
        kind="secondary"
        small
        style={{ margin: "8px 8px 8px 0px" }}
        href={`/saas_admin/accounts/${accountId}/cv_templates/${item.id}/edit`}
      >
        Edit
      </ButtonLink>
      <Button
        kind="danger"
        small
        style={{ margin: 8 }}
        onClick={() => {
          if (confirm(t("admin:sureToDelete", { key: item.key }))) {
            $.ajax({
              url: ApiRoute(`/api/cv_templates/${item.id}`),
              data: { account_id: accountId },
              method: "DELETE",
              api_version: 2
            })
              .then(() => {
                growl({ message: t("cvTemplates.destroy.success") });
                fetchTemplates();
              })
              .catch((errors) => {
                const parsedErrors = parseResponseErrors(errors?.responseJSON?.errors);
                growl({
                  message: parsedErrors?.basic || t("cvTemplates.destroy.error"),
                  kind: "error"
                });
              });
          }
        }}
      >
        Remove
      </Button>
    </div>
  );

  const cellRenderer = (attribute) => <span>{attribute}</span>;

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1>CV Templates</h1>
        <ButtonLink href={`/saas_admin/accounts/${accountId}/cv_templates/new`}>
          Create new CV template
        </ButtonLink>
      </div>
      <PageBox>
        {cvTemplates.length > 0 ? (
          <DataTable
            style={{ whiteSpace: "nowrap" }}
            columns={[
              {
                headerName: "Key",
                renderCell: (data) => cellRenderer(data.key)
              },
              {
                headerName: "Name",
                renderCell: (data) => cellRenderer(data.display_as)
              },
              {
                headerName: "Export Format",
                renderCell: (data) => cellRenderer(data.export_format)
              },
              {
                headerName: "Default",
                renderCell: (data) => cellRenderer(data.default ? "Yes" : "No")
              },
              {
                headerName: "Actions",
                renderCell: (data) => renderActions(data),
                narrow: true
              }
            ]}
            data={cvTemplates}
          />
        ) : (
          <div className={css.notFound}>CV templates not found</div>
        )}
      </PageBox>
    </div>
  );
};

CvTemplatesListPage.propTypes = {
  cvTemplates: PropTypes.array.isRequired,
  accountId: PropTypes.string.isRequired,
  fetchTemplates: PropTypes.func.isRequired
};

export default CvTemplatesListPage;
